import React from "react";
import ReactCountryFlag from "react-country-flag";

import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import { getCountryNameByCode } from "utils/utils";

import "./FieldCountryWithFlag.scss";

export default class FieldCountryWithFlag extends React.Component {
  static defaultProps = {
    countryCode: "",
    className: ""
  };
  generateContent = () => {
    const { countryCode } = this.props;
    return (
      <div className="flag-country-name">
        <ReactCountryFlag code={countryCode} />
        <span className="field-value-cell-value">
          {getCountryNameByCode(countryCode)}
        </span>
      </div>
    );
  };

  render() {
    const { title, className } = this.props;
    return (
      <FieldValueVerticalCell
        className={className}
        title={title}
        render={this.generateContent}
      />
    );
  }
}
